import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const GET_PROJETOS = "getProjetos";
export const GET_PROJETOS_BOX = "getProjetosBox";

// mutation types
export const SET_PROJETOS = "setProjetos";

const state = {
  projetos: []
};

const getters = {
  projetos(state) {
    return state.projetos;
  }
};

const actions = {
  [GET_PROJETOS](context) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.get("projetos").then(({ data }) => {
          context.commit(SET_PROJETOS, data);
          resolve(data);
        });
      }
    });
  },
  [GET_PROJETOS_BOX](context, filtros) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("projetosBox", filtros).then(({ data }) => {
          resolve(data);
        });
      }
    });
  }
};

const mutations = {
  [SET_PROJETOS](state, projetos) {
    state.projetos = projetos;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
